import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { GroupService } from 'shared/services/SS-Groups/groups.service';
import { AlertPopupService } from 'shared/services/SS-Alert/alert-popup.service';
import { DataSharingService } from 'shared/services/data-sharing/data-sharing.service';

@Component({
  selector: 'app-invite-code-modal',
  templateUrl: './invite-code-modal.component.html',
  styleUrls: ['./invite-code-modal.component.css']
})
export class InviteCodeModalComponent implements OnInit {
  inviteForm: FormGroup;
  loading: boolean;

  constructor(
    public dialogRef: MatDialogRef<InviteCodeModalComponent>,
    private router: Router,
    private groupService: GroupService,
    private alertService: AlertPopupService,
    private data: DataSharingService,
  ) { }

  ngOnInit() {
    this.inviteForm = new FormGroup({
      groupCode: new FormControl('', [Validators.required, Validators.minLength(4)]),
    });
  }

  joinGroup() {
    this.loading = true;
    this.groupService.isValidGroup(this.inviteForm.value.groupCode).subscribe(res => {
      // valid group, check invalid output
      this.loading = false;
      console.log(res)
      if (Number(res.glpreauth) !== 0) {
        this.dialogRef.close();
        this.data.holdDataService(res);
        this.router.navigate(['/new-group/charge-card'], { queryParams: { groupCode: this.inviteForm.value.groupCode }});
      } else {
        this.alertService.errorAlert('Invalid group response..');
      }
    }, err => {
      this.loading = false;
      this.alertService.toasterErrorAleart(err.error.message);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/group/components/new-group/invite-code-modal/invite-code-modal.component.ts